import { ChangeDetectorRef, Component,  Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Customer } from '../../models/customers/Customer';
import { Zoom } from '../../models/zoom/Zoom';
import { OfferpackService } from '../../services/offerpack.service';
import { AuthService } from '../../services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Offerpack } from '../../models/offerpack/Offerpack';
import { AuthGuardService } from '../../services/auth-guard.service';
import { ToolsService } from '../../services/tools.service';
import { ZoomService } from '../../services/zoom.service';
import { isPlatformBrowser, Location } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Clipboard } from '@angular/cdk/clipboard';
import { EncryptionService } from '../../services/encyption.service';
import { environment } from '../../../environments/environment';
import { MiniPartner } from '../../models/offerpack/MiniPartner';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { OfferpackformComponent } from '../modals/offerpackform/offerpackform.component';
import { CustomemailComponent } from '../modals/customemail/customemail.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ConfirmationComponent } from '../modals/confirmation/confirmation.component';
import { Title } from '@angular/platform-browser';
import { AcvisService } from '@app/services/acvis.service';
import { CommentComponent } from './comment/comment.component';
import { Partner } from '@app/models/partner/IPartner';
import { PartnerloginComponent } from '../modals/partnerlogin/partnerlogin.component';
@Component({
    selector: 'app-offerpack',
    templateUrl: './offerpack.component.html',
    styleUrls: ['./offerpack.component.scss'],
    standalone: false
})
export class OfferpackComponent implements OnInit, OnDestroy {
    private unsubscribe$ = new Subject();
    offerPack: Offerpack;
    createzoomloading: boolean = false;
    width: string = '24%';
    mediQ: string = 'xl';
    desktopTemplate: boolean = true;
    showPacklistForcustomer: boolean = false;
    loadingpackforcustomer: boolean = false;
    currentCustomer: Customer;
    bigtb: Array<Array<string>> = [];
    currentpartnerid: string;
    currentPartner: Partner;
    selectedCustomer: Customer;
    packpartner: MiniPartner;
    selectedCustomerPackList: Offerpack[] = [];

    limit: number = 50;
    skip: number = 0;
    totalOfofferpacklistcount: number = 0;
    importloading: boolean = false;
    sortrdirection: number = -1;
    totalOffers: number = -1;
    sortItem: string = 'date';
    reference: string = 'offerpack';

    // search customer
    shareLink = '';
    searchtarget = '';
    myCustomersfilteredOptions: Customer[];

    chImport: any;
    chImportAcvis: any;
    chImportCosmonaut: any;
    isBrowser: boolean = false;
    private loginDialogOpened: boolean = false;

    constructor(
        private offerpackService: OfferpackService,
        private authService: AuthService,
        private guardService: AuthGuardService,
        private route: ActivatedRoute,
        private toolsService: ToolsService,
        private dialog: MatDialog,
        private router: Router,
        private encservice: EncryptionService,
        private zoom: ZoomService,
        private location: Location,
        private clipboard: Clipboard,
        private snackBar: MatSnackBar,
        private acvisService: AcvisService,
        private titleService: Title,
        protected mediaObserver: BreakpointObserver,
        private cdr: ChangeDetectorRef,
        @Inject(PLATFORM_ID) private platformId: any
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    ngOnInit(): void {
        if (this.isBrowser) {
            const cleverstyle = document.getElementById('clever-custom-content-style');
            if (cleverstyle) {
                cleverstyle.innerText = '';
            }

            const cleverscript = document.getElementById('clever-custom-content-script');
            if (cleverscript) {
                cleverscript.innerHTML = '';
            }
            this.offerPack = {} as Offerpack;
            this.titleService.setTitle('Offerpack');
            this.initMedia();
            this.initPartner();
        }
    }

    async initAuth() {
        this.authService.auth$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((customer: Customer) => {
            if (customer?.email?.length > 0) {
                this.currentCustomer = customer;
                this.listenToImportChanel();
                this.listenaddoffer();
                this.initData();
            } else if (customer && !this.route.snapshot.params?.['packid']) {
                this.openLogin();
            } else if (customer) {
                // Shared offer-pack links remain accessible without a login.
                this.initData();
            }
        });
    }

    private openLogin(): void {
        if (this.loginDialogOpened) {
            return;
        }

        this.loginDialogOpened = true;
        const target: MatDialogConfig = this.desktopTemplate ? {
            width: '400px',
            panelClass: 'customModal',
            maxHeight: '100vh',
            disableClose: true,
            data: {
                partnerdomain: this.currentPartner?.partnerdomain,
                partnerid: this.currentpartnerid,
                modeLogin: true
            }
        } : {
            width: '100%',
            height: '100vh',
            maxWidth: '100%',
            panelClass: 'customModal',
            disableClose: true,
            data: {
                partnerdomain: this.currentPartner?.partnerdomain,
                partnerid: this.currentpartnerid,
                modeLogin: true
            }
        };

        this.dialog.open(PartnerloginComponent, target).afterClosed().pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((customer: Customer) => {
            this.loginDialogOpened = false;
            if (customer?.token?.length > 0 && this.currentCustomer?.token !== customer.token) {
                this.authService.setAuth(customer);
            }
        });
    }

    async initPartner() {
        this.guardService.getPartner$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((partner) => {
            if (partner?.partnerid?.length > 0) {
                this.currentpartnerid = partner.partnerid;
                this.currentPartner = partner;
                this.initAuth();
                this.ensureAuthenticated();
            }
        });
    }

    private ensureAuthenticated(): void {
        this.authService.isAuthenticated(this.currentpartnerid).then((authenticated) => {
            if (!authenticated && !this.route.snapshot.params?.['packid']) {
                this.openLogin();
            }
        });
    }

    async initMedia() {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.mediQ = 'xs';
            this.desktopTemplate = false;
            this.width = '100%';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.mediQ = 'sm';
            this.desktopTemplate = false;
            this.width = '48%';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.mediQ = 'md';
            this.desktopTemplate = true;
            this.width = '25%';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.mediQ = 'lg';
            this.desktopTemplate = true;
            this.width = '25%';
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.mediQ = 'xl';
            this.desktopTemplate = true;
            this.width = '25%';
        }
        this.cdr.detectChanges();
    }

    listenaddoffer() {
        this.offerpackService.offerpack$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((count: number) => {
            this.totalOffers = count;
            if (this.offerPack?.packlist) {
                this.offerPack.packlist = this.offerpackService.getofferpackListe();
            }
            this.cdr.detectChanges();
        });
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();

        // remove listener
        // this.chImport?.removeAllListeners('message');
        // this.chImportAcvis?.removeAllListeners('message');
        // this.chImportCosmonaut?.removeAllListeners('message');
    }

    async initData() {
        this.initOfferPack();
        if (this.route.snapshot.params?.['packid']?.length > 0) {
            this.offerPack.packid = this.route.snapshot.params?.['packid'];
            this.getpacklistbyid();
        } else {
            this.offerPack = this.offerpackService.getofferpack();
            this.packpartner = this.offerPack?.partner;
            this.changeurl();
        }
        // switchMap(term => this.request({target: value}, 'getcustomers', token))
    }

    initOfferPack(): void {
        this.offerPack = {} as Offerpack;
        this.offerPack.packlist = [];
        this.offerPack.packid = '';
        if (this.currentCustomer?.asPartner) {
            this.offerPack.partner = {
                email: this.currentCustomer.email,
                partneremail: this.currentPartner.email,
                salutation: this.currentCustomer.salutation,
                userid: this.currentCustomer.userid,
                partnerid: this.currentCustomer.partnerid,
                firstname: this.currentCustomer.firstname,
                lastname: this.currentCustomer.lastname,
                firmenname: this.currentPartner.firmenname,
                avatar: this.currentCustomer.avatar,
                description: this.currentCustomer.description,
                tel: this.currentCustomer.tel,
            } as MiniPartner;
        }
    }

    async searchData(value) {
        this.showPacklistForcustomer = false;
        if (value?.length > 0) {
            this.offerpackService.request({ target: value, partnerid: this.currentCustomer?.partnerid }, 'getcustomers', this.currentCustomer?.token).pipe(
                takeUntil(this.unsubscribe$)
            ).subscribe((res) => {
                if (res?.length > 0) {
                    this.myCustomersfilteredOptions = res;
                } else {
                    this.myCustomersfilteredOptions = [];
                    this.selectedCustomer = {} as Customer;
                    if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(value)) {
                        this.selectedCustomer.email = value;
                    }
                }
            });
        } else {
            this.selectedCustomer = null;
        }
    }

    async angebotLeern() {
        const dialogRef = this.dialog.open(ConfirmationComponent, {
            width: '500px',
            data: { message: 'Möchten Sie die Liste leeren?', title: 'Leeren' }
        });

        dialogRef.afterClosed().pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((result: any) => {
            if (result) {
                this.removeOffers();
            }
        });
    }

    async removeOffers() {
        this.offerPack.packlist = [];
        this.selectedCustomer = {} as Customer;
        this.searchtarget = '';
        this.selectedCustomerPackList = [];
        this.totalOfofferpacklistcount = 0;
        this.offerpackService.resetOfferpackList();
        if (this.showPacklistForcustomer) {
            this.offerpacklistForCustomer();
        }
    }

    async removeFromList(id) {
        const dialogRef = this.dialog.open(ConfirmationComponent, {
            width: '500px',
            data: { message: 'Möchten Sie die Auswahl wirklich löschen?', title: 'Löschen' }
        });

        dialogRef.afterClosed().pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((result: any) => {
            if (result) {
                this.offerpackService.removeOffer(id);
            }
        });
    }

    async selectedCustomerF(ev) {
        for (let i = 0; i < this.myCustomersfilteredOptions.length; i++) {
            if (this.myCustomersfilteredOptions[i].email === ev.option.value) {
                this.selectedCustomer = this.myCustomersfilteredOptions[i];
                i = this.myCustomersfilteredOptions.length;
            }
        }
    }

    async openPackList() {
        this.showPacklistForcustomer = !this.showPacklistForcustomer;
        if (this.showPacklistForcustomer) {
            this.offerpacklistForCustomer();
        }
    }

    async sendToClient() {
        if (this.selectedCustomer?.email?.length > 0 && this.currentCustomer?.asPartner) {
            this.showPacklistForcustomer = false;
            this.offerPack.partner = {
                email: this.currentCustomer.email,
                partneremail: this.currentPartner.email,
                salutation: this.currentCustomer.salutation,
                userid: this.currentCustomer.userid,
                partnerid: this.currentCustomer.partnerid,
                firstname: this.currentCustomer.firstname,
                lastname: this.currentCustomer.lastname,
                firmenname: this.currentPartner.firmenname,
                avatar: this.currentCustomer.avatar,
                description: this.currentCustomer.description,
                tel: this.currentCustomer.tel,
            } as MiniPartner;

            if (this.offerPack.packid?.length > 0 && this.selectedCustomer?.customerid > 0 && this.offerPack.customer?.email === this.selectedCustomer.email) {
                this.offerPack.customer = this.selectedCustomer;
                // this.offerPack.customerid = this.searchtarget;
                const target = {
                    partnerid: this.guardService.getPartnerId(),
                    offerPack: this.offerPack,
                    packid: this.offerPack.packid,
                };
                this.offerpackService.request(target, 'updatepacklist', this.currentCustomer.token).pipe(
                    takeUntil(this.unsubscribe$)
                ).subscribe((res: Offerpack) => {
                    if (!res?.error) {
                        this.sendToCustomerMail();
                    } else {
                        this.snackBar.open('Konnte nicht gespeichert werden', 'Schließen', {
                            panelClass: 'error',
                            duration: 3000,
                        });
                    }
                });
            } else {
                if (
                    this.selectedCustomer?.customerid > 0 &&
                    this.selectedCustomer?.firstname?.length > 0 &&
                    this.selectedCustomer?.lastname?.length > 0 &&
                    this.selectedCustomer?.email?.length > 0
                ) {
                    this.createofferpack();
                } else {
                    this.openCustomerDataModal();
                }
            }
        }
    }

    async createofferpack() {
        if (this.currentCustomer?.asPartner) {
            let createNewId = true;
            if (!this.offerPack?.customer || !this.offerPack?.customer?.email || this.offerPack?.customer?.email.length === 0) {
                createNewId = false;
            }
            this.offerPack.customer = this.selectedCustomer;
            this.offerPack.partnerzoomurl = '';
            this.offerPack.customerzoomurl = '';
            const target = {
                partnerid: this.guardService.getPartnerId(),
                offerPack: this.offerPack,
                createNewId: createNewId
            };
            this.offerPack.partner = {
                email: this.currentCustomer.email,
                partneremail: this.currentPartner.email,
                salutation: this.currentCustomer.salutation,
                userid: this.currentCustomer.userid,
                partnerid: this.currentCustomer.partnerid,
                firstname: this.currentCustomer.firstname,
                lastname: this.currentCustomer.lastname,
                firmenname: this.currentPartner.firmenname,
                avatar: this.currentCustomer.avatar,
                description: this.currentCustomer.description,
                tel: this.currentCustomer.tel,
            } as MiniPartner;
            this.offerpackService.request(target, 'createofferpack', this.currentCustomer.token).pipe(
                takeUntil(this.unsubscribe$)
            ).subscribe(res => {
                if (!res.error && res.id?.length > 0) {
                    this.offerPack.packid = res.id;
                    this.offerpackService.setOfferpackdata(this.offerPack);
                    this.changeurl();
                    this.createLing();
                    this.sendToCustomerMail();
                } else {
                    this.snackBar.open('Konnte nicht gesendet werden', 'Schließen', {
                        panelClass: 'error',
                        duration: 3000,
                    });
                }
            });
        }
    }

    createLing(): void {
        this.shareLink = '/offerpack/' + this.offerPack.packid;
    }

    async copylink() {
        this.clipboard.copy(window.location.origin + '/offerpack/' + this.offerPack.packid);
        this.snackBar.open('Link erfolgreich kopiert', 'Schließen', {
            panelClass: 'success',
            duration: 3000,
        });
    }

    async createLink() {
        if (this.offerPack.packlist?.length > 0) {
            this.offerPack.partner = {
                email: this.currentCustomer.email,
                partneremail: this.currentPartner.email,
                salutation: this.currentCustomer.salutation,
                userid: this.currentCustomer.userid,
                partnerid: this.currentCustomer.partnerid,
                firstname: this.currentCustomer.firstname,
                lastname: this.currentCustomer.lastname,
                firmenname: this.currentPartner.firmenname,
                avatar: this.currentCustomer.avatar,
                description: this.currentCustomer.description,
                tel: this.currentCustomer.tel,
            } as MiniPartner;
            this.offerPack.customer = null;
            const target = {
                partnerid: this.guardService.getPartnerId(),
                offerPack: this.offerPack,
            };
            this.offerpackService.request(target, 'createofferpack', this.currentCustomer.token).pipe(
                takeUntil(this.unsubscribe$)
            ).subscribe(res => {
                if (!res.error && res.id?.length > 0) {
                    this.offerPack.packid = res.id;
                    this.packpartner = this.offerPack?.partner;
                    this.offerpackService.setOfferpackdata(this.offerPack);
                    this.changeurl();
                    this.createLing();
                    this.snackBar.open('Erfolgreich erstellt', 'Schließen', {
                        panelClass: 'success',
                        duration: 3000,
                    });
                } else {
                    this.snackBar.open('Konnte nicht erstellt werden', 'Schließen', {
                        panelClass: 'error',
                        duration: 3000,
                    });
                }
                this.cdr.detectChanges();
            });
        }
    }

    async resetpackliste() {
        this.packpartner = {} as MiniPartner;
        this.initOfferPack();
        this.removeOffers();
        this.changeurl();
    }

    async createZoom() {
        if (this.currentCustomer?.email?.length > 0) {
            this.createzoomloading = true;
            const token = window.localStorage.getItem(this.currentCustomer?.partnerid + '_access_token');
            this.zoom.request(token, { email: this.currentCustomer.email }, 'zoom/createnewmeeting', this.currentpartnerid).pipe(
                takeUntil(this.unsubscribe$)
            ).subscribe((zoom: Zoom) => {
                if (zoom?.id > 0) {
                    this.zoom.request(token, { role: 0, meetingNumber: zoom.id }, 'zoom/zoomsignature', this.currentpartnerid).pipe(
                        takeUntil(this.unsubscribe$)
                    ).subscribe((res) => {
                        if (res?.signature?.length > 0) {
                            const webzoom = {
                                signatureEndpoint: res.signature,
                                apiKey: this.toolsService.getZoomID(),
                                meetingNumber: zoom.id,
                                leaveUrl: res.leaveUrl,
                                userName: this.toolsService.getZoomUsername(),
                                userEmail: this.toolsService.getZoomEmail(),
                                passWord: this.toolsService.getZoomPassword()
                            };
                            this.offerPack.partnerzoomurl = zoom.start_url;
                            const params = this.encservice.encrypt(webzoom);
                            let suffixsdomain;
                            if (environment.production) {
                                if (document.domain.startsWith('demo')) {
                                    suffixsdomain = 'https://zoom'
                                } else {
                                    suffixsdomain = 'https://zoom.'
                                }
                                this.offerPack.customerzoomurl = suffixsdomain + document.domain + '?param=' + params;
                            } else {
                                this.offerPack.customerzoomurl = 'https://localhost:3336?param=' + params;
                            }
                            this.saveList();
                        }
                        this.createzoomloading = false;
                    });
                } else {
                    this.createzoomloading = false;
                    this.snackBar.open('Zoom Account konnte nicht gefunden werden', 'Schließen', {
                        panelClass: 'error',
                        duration: 3000,
                    });
                }
            });
        } else {
            this.snackBar.open('Zoom Account konnte nicht gefunden werden', 'Schließen', {
                panelClass: 'error',
                duration: 3000,
            });
        }
    }

    async openZoomForCustomer() {
        window.open(this.offerPack.customerzoomurl, '_blank', 'noopener');
    }

    async openZoomForPartner() {
        window.open(this.offerPack.partnerzoomurl, '_blank', 'noopener');
    }

    async getpacklistbyid() {
        if (this.offerPack?.packid?.length > 0) {
            this.offerpackService.request({ packid: this.offerPack.packid, partnerid: this.currentpartnerid, asPartner: this.currentCustomer?.asPartner }, 'offerpacklist', this.currentCustomer?.token).pipe(
                takeUntil(this.unsubscribe$)
            ).subscribe((res: Offerpack) => {
                if (res?.packid?.length > 0) {
                    this.createLing();
                    this.offerPack = res || {} as Offerpack;
                    // this.divliste();
                    this.selectedCustomer = this.offerPack?.customer;
                    this.packpartner = this.offerPack?.partner;
                    this.searchtarget = this.offerPack?.customer?.email;
                    this.offerPack.packlist = this.offerPack.packlist?.length > 0 ? this.offerPack.packlist : [];
                    this.offerpackService.setOfferpackdata(this.offerPack);
                    if (this.offerPack?.partner?.firstname?.length > 0) {
                        this.reference = 'offerpack_' + this.offerPack?.partner.firstname + '_' + this.offerPack?.partner.lastname + '_' + this.offerPack.packid;
                    } else {
                        this.reference = 'offerpack_' + this.offerPack.packid;
                    }
                    this.changeurl();
                    if (this.currentCustomer?.token?.length > 0) {
                        this.showPacklistForcustomer = false;
                    }
                    this.cdr.detectChanges();
                } else {
                    this.resetpackliste();
                }
            });
        }
    }

    async sortCustomerlist(sortitem) {
        if (this.sortItem === sortitem) {
            this.sortrdirection = -1 * this.sortrdirection;
        } else {
            this.sortItem = sortitem;
            this.sortrdirection = 1;
        }
        this.offerpacklistForCustomer();
    }

    async offerpacklistForCustomer() {
        this.loadingpackforcustomer = true;
        const target = {
            limit: this.limit,
            skip: this.skip,
            direction: this.sortrdirection,
            sortitem: this.sortItem,
            email: this.selectedCustomer?.email,
            partnerid: this.currentCustomer.partnerid,
            userid: this.currentCustomer.userid
        };
        this.offerpackService.request(target, 'offerpacklistForCustomer', this.currentCustomer.token).pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((res) => {
            if (!res?.error && res?.offerpacks?.length > 0) {
                this.selectedCustomerPackList = res.offerpacks;
                this.totalOfofferpacklistcount = res.offercount;
            } else {
                this.selectedCustomerPackList = [];
                this.totalOfofferpacklistcount = 0;
            }
            this.loadingpackforcustomer = false;
            this.cdr.detectChanges();
        });
    }

    // pagination previous
    async previous() {
        this.skip = this.skip - 50;
        this.limit = this.limit - (this.limit % 50 > 0 ? this.limit % 50 : 50);
        this.offerpacklistForCustomer();
    }

    // pagination next
    async next() {
        if ((this.limit + 50) < this.totalOfofferpacklistcount) {
            this.skip = this.skip + 50;
            this.limit = this.limit + 50;
        } else {
            this.skip = this.skip + 50;
            this.limit = this.totalOfofferpacklistcount;
        }
        this.offerpacklistForCustomer();
    }

    async changeurl() {
        if (this.offerPack.packid?.length > 0) {
            const url = this.router.createUrlTree(['offerpack/' + this.offerPack.packid], /* Removed unsupported properties by Angular migration: replaceUrl. */ {}).toString();
            this.location.go(url);
        } else {
            const url = this.router.createUrlTree(['offerpack'], /* Removed unsupported properties by Angular migration: replaceUrl. */ {}).toString();
            this.location.go(url);
        }
    }

    async gotoGetPack(ev) {
        if (ev.keyCode === 13) {
            this.getpacklistbyid();
        }
    }

    async gotoSelectedPack(pack: Offerpack) {
        if (pack?.packid?.length > 0) {
            this.offerPack = pack;
            this.getpacklistbyid();
        }
    }

    async saveList() {
        if (this.offerPack.packid?.length > 0 && this.offerPack.packlist?.length > 0) {
            const target = {
                offerPack: this.offerPack,
                partnerid: this.guardService.getPartnerId(),
            }
            this.offerpackService.request(target, 'updatepacklist', this.currentCustomer.token).pipe(
                takeUntil(this.unsubscribe$)
            ).subscribe((res: Offerpack) => {
                if (!res?.error) {
                    this.snackBar.open('Erfolgreich gespeichert', 'Schließen', {
                        panelClass: 'success',
                        duration: 3000,
                    });
                } else {
                    this.snackBar.open('Konnte nicht gespeichert werden', 'Schließen', {
                        panelClass: 'error',
                        duration: 3000,
                    });
                }
            });
        }
    }

    async sendToCustomerMail() {
        if (this.offerPack.partner.email?.length > 0) {
            let html = '<b>Vielen Dank für Ihre Anfrage</b>';
            const url = window.location.origin + '/offerpack/' + this.offerPack.packid;
            html += '<br><br>';
            html += 'Sehr ' + (this.selectedCustomer?.salutation === 'Frau' ? 'geehrte ' : 'geehrter ') + (this.selectedCustomer?.salutation ? this.selectedCustomer.salutation : 'Herr/Frau') + ' ' + this.selectedCustomer.firstname + ' ' + this.selectedCustomer.lastname;
            html += '<br><br>';
            html += 'gerne haben wir passend nach Ihren Wünschen und Vorstellungen einige tolle Urlaubs-Angebote erstellt und freuen uns, Ihnen diese präsentieren zu dürfen.</b>';
            html += 'Die Angebote können Sie sich jederzeit unter Ihrem persönlichen Link aufrufen:</b>';
            html += '<br><br>';
            html += '<a href="{{url}}">{{url}}</a>';
            html += '<br><br>';
            html += 'Bitte beachten Sie, dass es sich um tagesaktuelle Angebote handelt. Preise sowie Verfügbarkeiten können sich jederzeit verändern. Sollten Sie weitere Fragen oder Änderungswünsche hierzu haben, dürfen Sie uns gerne  kontaktieren.';
            html += '<br><br>';
            html += 'Sicherlich konnten wir Ihnen mit diesen Informationen weiterhelfen und würden uns freuen, wenn das passende Angebot für Sie dabei ist. Auf diesem Weg wünschen wir Ihnen einen schönen Tag und viel Freude beim Träumen von Ihrem kommenden Urlaub.';
            html += '<br><br>';
            html += 'Falls Sie bereits ein Angebot von einem unserer Mitbewerber erhalten haben, lassen Sie es uns wissen. Wir erstellen Ihnen gerne ein Gegenangebot, das mindestens zum selben Preis, wenn nicht sogar günstiger ist. Wir garantieren Ihnen den besten Preis! In unserem Sortiment führen wir sämtliche namhafte Reiseveranstalter um Ihnen eine breite Auswahl an erstklassigen Reiseoptionen anbieten zu können. Profitieren Sie von unserem Preisversprechen!';
            html += '<br><br>';
            html += 'Mit freundlichen Grüßen';
            html += '<br><br>';
            html += this.offerPack.partner.firstname + ' ' + this.offerPack.partner.lastname;
            html += '<br>Reiseexperte<br>';
            html += this.offerPack.partner.firmenname;
            html += '<br><br>';
            if (this.offerPack.partner?.email?.length > 0) {
                html += 'E-Mail: ' + this.offerPack.partner?.partneremail;
                html += '<br><br>';
            }
            if (this.offerPack.partner?.tel?.length > 0) {
                html += 'Zentrale Rufnummer:<br>';
                html += 'Telefon: ' + this.offerPack.partner?.tel;
            }
            const dialogRef = this.dialog.open(CustomemailComponent, {
                width: this.desktopTemplate ? '80vw' : '100%',
                height: this.desktopTemplate ? '80vh' : '100%',
                maxWidth: '100%',
                panelClass: 'customModal',
                data: {
                    currentCustomer: this.currentCustomer,
                    url: url,
                    name: this.offerPack.partner.firstname + ' ' + this.offerPack.partner.lastname,
                    subject: 'Reiseangebote',
                    from: this.offerPack.partner.email,
                    email: this.selectedCustomer?.email,
                    cc: '',
                    text: '',
                    html: html
                }
            });
            dialogRef.afterClosed().pipe(
                takeUntil(this.unsubscribe$)
            ).subscribe((result: string) => {
                if (result) {
                    this.sendMail(result);
                }
            });
        }
    }

    async sendMail(data) {
        let emailBody = '';
        emailBody += '<html>';
        emailBody += '<head>';
        emailBody += '<meta http-equiv="Content-Type" content="text/html; charset=UTF-8">';
        emailBody += '<meta name="viewport" content="width=device-width, initial-scale=1.0">';
        emailBody += '<style type="text/css">';
        emailBody += `
        HTMLBody, body {
            background-color: #f3f3f3;
        }
        table {
            mso-table-lspace: 0pt;
            mso-table-rspace: 0pt;
            border-collapse: collapse;
            border-spacing: 0px;
            outline: 0;
            margin: 5px;
        }
        `;
        emailBody += '</style>';
        emailBody += '</head>';
        emailBody += '<HTMLBody bgcolor="#f3f3f3">';
        emailBody += '<table><tr><td>';
        emailBody += data.html;
        emailBody += '</td></tr></table>';
        emailBody += '</HTMLBody></html>';
        const target = {
            from: data.name + ' <' + data.from + '>',
            email: data.email,
            subject: data.subject,
            html: emailBody,
            cc: data.cc,
            partnerid: this.offerPack.partner.partnerid,
            packid: this.offerPack.packid,
        };
        this.offerpackService.request(target, 'sendOfferpackEmailToCustomer', this.currentCustomer.token).pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe(res => {
            if (!res?.error) {
                this.snackBar.open('Erfolgreich versendet', 'Schließen', {
                    panelClass: 'success',
                    duration: 3000,
                });
            } else {
                this.snackBar.open(res.error, 'Schließen', {
                    panelClass: 'error',
                    duration: 3000,
                });
            }
        });
    }

    async openCustomerDataModal() {
        let target;
        if (this.desktopTemplate) {
            target = {};
        } else {
            target = { width: '100%', height: '100%', maxWidth: '100%' };
        }
        const resf = this.dialog.open(OfferpackformComponent, target);
        resf.afterClosed().pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((res) => {
            if (res) {
                this.selectedCustomer.salutation = res.salutation;
                this.selectedCustomer.firstname = res.firstname;
                this.selectedCustomer.lastname = res.lastname;
                this.selectedCustomer.tel = res.tel;
                this.createofferpack();
            }
        });
    }

    trackByFn(index, item) {
        return item.offerid; // or item.id
    }

    listenToImportChanel() {
        try {
            this.chImport?.removeAllListeners('message');
            this.chImportAcvis?.removeAllListeners('message');
            this.chImportCosmonaut?.removeAllListeners('message');
            // eslint-disable-next-line no-undef
            this.chImport = new BroadcastChannel('_import_in_suntour_offerpack_full_' + this.currentCustomer.partnerid);
            this.chImport.addEventListener('message', (e) => {
                this.importFromExtern([e.data]);
                for (let i = 0; i < e.data.offers?.length; i++) {
                    this.offerpackService.addOffer({ offerid: e.data.offers[i].offerid, type: e.data.offers[i].type });
                }
                this.cdr.detectChanges();
            });

            // eslint-disable-next-line no-undef
            this.chImportAcvis = new BroadcastChannel('_import_in_suntour_offerpack_acvis_' + this.currentCustomer.partnerid);
            this.chImportAcvis.addEventListener('message', (e) => {
                this.importFromExternAcvis(e.data);
            });

            // eslint-disable-next-line no-undef
            this.chImportCosmonaut = new BroadcastChannel('_import_in_suntour_offerpack_cosmonaut_' + this.currentCustomer.partnerid);
            this.chImportCosmonaut.addEventListener('message', (e) => {
                // console.log(e)
                if (e.data.offerid?.length > 0) {
                    this.offerpackService.addOffer({ offerid: e.data.offerid, type: e.data.type });
                }
            });
        } catch (error) {
            console.log('BroadcastChannel is not supported')
        }
    }

    async importFromExtern(offers?) {
        this.importloading = true;
        try {
            if (!offers) {
                offers = JSON.parse(await navigator.clipboard.readText());
            }
            this.offerpackService.request({ offers: offers, partnerid: this.currentCustomer?.partnerid, username: this.currentCustomer.email }, 'importFromextern', this.currentCustomer?.token).pipe(
                takeUntil(this.unsubscribe$)
            ).subscribe((res) => {
                if (res && res.error) {
                    this.snackBar.open(res.error, 'Schließen', {
                        panelClass: 'error',
                        duration: 3000,
                    });
                } else {
                    for (let i = 0; i < res.offers?.length; i++) {
                        this.offerpackService.addOffer({ offerid: res.offers[i].offerid, type: res.offers[i].type });
                    }
                }
                this.importloading = false;
            });
        } catch (error) {
            console.log(error);
            this.importloading = false;
            this.snackBar.open(error, 'Schließen', {
                panelClass: 'error',
                duration: 3000,
            });
        }
    }

    async importFromExternAcvis(offers?) {
        try {
            if (offers.offerid?.length > 0) {
                this.acvisService.request({ offerid: offers.offerid, partnerid: this.currentCustomer.partnerid, username: this.currentCustomer.email }, 'getftiofferpackbyid').pipe(
                    takeUntil(this.unsubscribe$)
                ).subscribe(res => {
                    if (res && res.error) {
                        // console.log(res)
                    } else {
                        this.offerpackService.addOffer({ offerid: res.offerid, type: res.type });
                    }
                });
            }
        } catch (error) {
            console.log(error);
        }
    }

    async changeindex(ev) {
        if (ev.dragedindex >= 0 && ev.dropindex >= 0 && this.offerPack?.packlist[ev.dragedindex] && this.offerPack?.packlist[ev.dropindex]) {
            this.offerPack?.packlist.splice(ev.dropindex, 0, this.offerPack.packlist.splice(ev.dragedindex, 1)[0]);
        }
    }

    async openSetComment() {
        let target = {} as MatDialogConfig;
        if (this.mediQ !== 'xs' && this.mediQ !== 'sm') {
            target = {
                width: '600px',
                data: {
                    title: 'Extra info',
                    message: this.offerPack.extracomment
                },
                autoFocus: false
            };
        } else {
            target = {
                width: '100%',
                height: '100%',
                maxWidth: '100%',
                // panelClass: 'customModal',
                data: {
                    title: 'Extra info',
                    message: this.offerPack.extracomment
                },
                autoFocus: false
            }
        }
        const resf = this.dialog.open(CommentComponent, target);
        resf.afterClosed().pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((data) => {
            if (data) {
                this.offerPack.extracomment = data?.message;
            }
        });
    }
}
